<div id="showing-timeselect-container" class="prospect-grid-container">
  <div class="bg-gray-300 w-full sm:w-1/2 flex flex-col text-center flex-justify-center text- base">
    <h5 class="flex flex-col flex-justify-center">Select Open House:</h5>
    <br>
      <div class="flex flex-col justify-center text-center">
        <mat-selection-list #show [multiple]="false">
          <mat-list-option *ngFor="let openHouse of openHouses; let i = index" (click)="selectOpenHouse(i)" [value]="show">
            <span>{{openHouse.DateTitle}}</span><span>{{openHouse.StartTime}} - {{openHouse.EndTime}}</span>
          </mat-list-option>
        </mat-selection-list>
      </div>  
    <div id="oh-select-bottom">
        <button mat-flat-button color="primary" class=" w-full my-4 font-normal text-2xl sm:text-base" [disabled]="selectedOpenHouse === null" (click)="onSubmit()">NEXT</button>
    </div>
  </div>
</div>
